import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

/** Admin-only routes — require admin session (user session can coexist). */
const AdminRoute = ({ element: Component, ...rest }) => {
  const { adminAuthenticated } = useAuth();

  if (!adminAuthenticated) return <Navigate to="/admin/login" replace />;
  return <Component {...rest} />;
};

export default AdminRoute;
